import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';
import { toastr } from 'react-redux-toastr';
import { tooltipHide } from '../../actions/tooltipActions';

// api
import paymentDetailsAPI from '../../sources/api/paymentDetailsAPI';

// constants
import { RENEW_SUBSCRIPTION } from '../../constants/paymentDetailsTypes';
import { RENEW_SUBSCRIPTION_MODAL } from '../../constants/modals';
import { RENEW_SUBSCRIPTION_SUCCESS, RENEW_SUBSCRIPTION_ERROR } from '../../constants/messages';
// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { paymentDetailsSchema } from '../../schemas/Normalizr';

export function* renewSubscription(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(RENEW_SUBSCRIPTION, call(paymentDetailsAPI.renewSubscription, params), paymentDetailsSchema);
    yield put(tooltipHide({ id: RENEW_SUBSCRIPTION_MODAL }));
    yield toastr.success('Success', RENEW_SUBSCRIPTION_SUCCESS);
  } catch (e) {
    yield toastr.error(RENEW_SUBSCRIPTION_ERROR);
    yield put(error(RENEW_SUBSCRIPTION, e));
  } finally {
    yield put(doneIndicator(RENEW_SUBSCRIPTION));
  }
}

export function* watchRenewSubscription() {
  yield takeEvery(RENEW_SUBSCRIPTION, renewSubscription);
}

export default function* root() {
  yield all([
    fork(watchRenewSubscription)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/paymentDetails/renewSubscription.js